<div class="info">
  <div class="info-wrapper">
    <div class="info-messages">
      @for (link of headerLinks; track $index) {
        @if (link.targetUrl) {
          @let sameSiteLink = sameSite(link);
          @if (sameSiteLink) {
            <a class="info-message link" [routerLink]="sameSiteLink.targetUrl" [target]="sameSiteLink.new ? '_blank' : '_self'">
              {{ sameSiteLink.titleText }}
            </a>
          }
          @if (!sameSiteLink) {
            <a class="info-message link" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'">
              {{ link.titleText }}
            </a>
          }
        }
        @if (!link.targetUrl) {
          <span class="info-message">{{ link.titleText }}</span>
        }
      }
    </div>

    @if (enableMembers) {
      <app-member-bar></app-member-bar>
    }
  </div>
</div>
<div class="spacer">
  <div class="mobileMenu">
    <app-icon-button [icon]="mobileMenuIcon" id="menu" [border]="false" (click)="openMobileMenu()"></app-icon-button>
  </div>
  <a routerLink="/" class="logo-container">
    <img [src]="storeLogo.src | cms: 50" [alt]="storeLogo.alt" />
  </a>
  <ul class="links unstyled">
    @for (link of links; track $index) {
      @if (link.type === 'link') {
        @let sameSiteLink = sameSite(link);
        @if (sameSiteLink) {
          <a class="nav" [routerLink]="sameSiteLink.targetUrl" [target]="sameSiteLink.new ? '_blank' : '_self'">
            {{ sameSiteLink.titleText }}
          </a>
        }
        @if (!sameSiteLink) {
          <a class="nav" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'">{{ link.titleText }}</a>
        }
      }

      @if (link.type === 'subNav') {
        <div class="sub-nav">
          <a
            [class.no-pointer]="!link.link"
            [class.open]="openNavigationName === link.title"
            class="nav"
            (mouseenter)="openNavigation(navContent, link.title)"
            (focus)="openNavigation(navContent, link.title)"
            [routerLink]="link.link ? [link.link] : []"
            (click)="link.link && closeNavigation()"
            [target]="link.linkTarget"
            tabindex="0"
          >
            {{ link.title }}
          </a>
          <div class="sub-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
            <ul class="unstyled">
              @for (navLink of link.pages; track $index) {
                @let sameSiteLink = sameSite(navLink);
                @if (sameSiteLink) {
                  <a
                    class="nav small"
                    [routerLink]="sameSiteLink.targetUrl"
                    [target]="sameSiteLink.new ? '_blank' : '_self'"
                    (focus)="openNavigation(navContent, link.title)"
                    (click)="closeNavigation()"
                  >
                    {{ sameSiteLink.titleText }}
                  </a>
                }
                @if (!sameSiteLink) {
                  <a
                    class="nav small"
                    [href]="navLink.targetUrl"
                    [target]="navLink.new ? '_blank' : '_self'"
                    (focus)="openNavigation(navContent, link.title)"
                    (click)="closeNavigation()"
                  >
                    {{ navLink.titleText }}
                  </a>
                }
              }
            </ul>
          </div>
        </div>
      }

      @if (link.type === 'burger') {
        <div class="burger-nav">
          <a
            [class.no-pointer]="!link.link"
            [class.open]="openNavigationName === link.title"
            class="nav"
            (mouseenter)="openNavigation(navContent, link.title)"
            (focus)="openNavigation(navContent, link.title)"
            [routerLink]="link.link ? [link.link] : []"
            (click)="link.link && closeNavigation()"
            [target]="link.linkTarget"
            tabindex="0"
          >
            {{ link.title }}
          </a>
          <div class="burger-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
            <ul class="unstyled">
              @for (navLink of link.pages; track $index) {
                @let sameSiteLink = sameSite(navLink);
                @if (sameSiteLink) {
                  <a
                    class="nav"
                    [routerLink]="sameSiteLink.targetUrl"
                    [target]="sameSiteLink.new ? '_blank' : '_self'"
                    (focus)="openNavigation(navContent, link.title)"
                    (click)="closeNavigation()"
                    >{{ sameSiteLink.titleText }}
                  </a>
                }
                @if (!sameSiteLink) {
                  <a
                    class="nav"
                    [href]="navLink.targetUrl"
                    [target]="navLink.new ? '_blank' : '_self'"
                    (focus)="openNavigation(navContent, link.title)"
                    (click)="closeNavigation()"
                    >{{ navLink.titleText }}
                  </a>
                }
              }
            </ul>
          </div>
        </div>
      }

      @if (link.type === 'categoryBurger') {
        <div class="burger-nav">
          <a
            [class.no-pointer]="!link.link"
            [class.open]="openNavigationName === link.title"
            class="nav"
            (mouseenter)="openNavigation(navContent, link.title)"
            (focus)="openNavigation(navContent, link.title)"
            [routerLink]="link.link ? [link.link] : []"
            (click)="link.link && closeNavigation()"
            [target]="link.linkTarget"
            tabindex="0"
          >
            {{ link.title }}
          </a>
          <div class="burger-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
            <ul class="unstyled">
              @for (navLink of link.pages; track $index) {
                @let sameSiteLink = sameSite(navLink);
                @if (sameSiteLink) {
                  <a
                    class="nav"
                    [routerLink]="sameSiteLink.targetUrl"
                    [target]="sameSiteLink.new ? '_blank' : '_self'"
                    (focus)="openNavigation(navContent, link.title)"
                    (click)="closeNavigation()"
                    >{{ sameSiteLink.titleText }}
                  </a>
                }
                @if (!sameSiteLink) {
                  <a
                    class="nav"
                    [href]="navLink.targetUrl"
                    [target]="navLink.new ? '_blank' : '_self'"
                    (focus)="openNavigation(navContent, link.title)"
                    (click)="closeNavigation()"
                    >{{ navLink.titleText }}
                  </a>
                }
              }
            </ul>
          </div>
        </div>
      }
    }
  </ul>
  <div class="shipping-basket-wrapper">
    <div class="basket">
      <app-icon-button [icon]="basketIcon" (click)="openBasket()" [border]="false" [matBadge]="count$ | async"></app-icon-button>
    </div>
  </div>
</div>
